import { render } from "./SimpleSelect.vue?vue&type=template&id=07d41e24&scoped=true&ts=true"
import script from "./SimpleSelect.vue?vue&type=script&lang=ts"
export * from "./SimpleSelect.vue?vue&type=script&lang=ts"

import "./SimpleSelect.vue?vue&type=style&index=0&id=07d41e24&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-07d41e24"]])

export default __exports__